import { render, staticRenderFns } from "./ViewDetailModal.vue?vue&type=template&id=6b678fb0&"
import script from "./ViewDetailModal.vue?vue&type=script&lang=js&"
export * from "./ViewDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports